import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileActionBar from "./MobileActionBar";
import AmbientMusic from "./AmbientMusic";
import { Toaster } from "./ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <div className="grain min-h-screen bg-ink text-foreground">
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <div className="h-[62px] md:hidden" aria-hidden="true" />
      <MobileActionBar />
      <AmbientMusic />
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}
